import cn from 'classnames';
import './viewToggle.scss';

type ViewToggleOption<T extends string> = {
  icon?: string;
  label: string;
  value: T;
};

type Props<T extends string> = {
  onChange: (value: T) => void;
  options: [ViewToggleOption<T>, ViewToggleOption<T>, ...ViewToggleOption<T>[]];
  value: T;
  variant?: 'ai' | 'interaction';
  className?: string;
};

export function ViewToggle<T extends string>({ onChange, options, value, variant = 'ai', className }: Props<T>) {
  return (
    <div className={cn(`viewToggle viewToggle--${variant}`, className)}>
      {options.map(option => (
        <button
          aria-pressed={value === option.value}
          key={option.value}
          onClick={() => onChange(option.value)}
          type="button"
        >
          {option.icon !== undefined && <i className={option.icon} />}
          {option.label}
        </button>
      ))}
    </div>
  );
}
